// import: styles
import { Box, Modal } from '@mui/material';
import BaseButton from 'core/components/button/BaseButton';

// import: components
import BaseTypography from 'core/components/typography/BaseTypography';
import { deletePromptConfirmationModalStyles } from 'core/layouts/components/delete-prompt-confirmation-modal/DeletePromptConfirmationModalStyles';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
// import: assets
// import: constants
// import: utils
// import: redux
import {
	multiDeleteImageAsync,
	openMultipleDeletePromptConfirmationModalSelector,
	studioSelectedImagesSelector,
	toggleMultiDeletePromptConfirmationModal,
} from 'core/store/reducers/studioReducer/StudioSlice';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

function DeletePromptConfirmationModal() {
	const dispatch = useDispatch();

	const selectedMedia = useSelector(studioSelectedImagesSelector);
	const { open, title, subtitle } = useSelector(openMultipleDeletePromptConfirmationModalSelector);
	const handleClose = () => {
		dispatch(toggleMultiDeletePromptConfirmationModal({ open: false }));
	};

	return (
		<Modal
			open={Boolean(open)}
			onClose={handleClose}
			aria-labelledby="delete-prompt-confirmation-modal"
			aria-describedby="Are you sure you want to delete this prompt?"
		>
			<Box id="modal-wrapper" sx={deletePromptConfirmationModalStyles.modalWrapper}>
				<Box id="modal-body" sx={deletePromptConfirmationModalStyles.modalBody}>
					<Box sx={[reusableStyles.flexCol, { gap: '4px' }]}>
						<BaseTypography
							variant="b1_medium"
							styles={{ color: 'colors.light3', textAlign: 'center' }}
						>
							{title || (selectedMedia.length > 1 ? 'Delete Generations?' : 'Delete Generation?')}
						</BaseTypography>
						<BaseTypography
							variant="b3_regular"
							styles={{ color: 'colors.light4', textAlign: 'center' }}
						>
							{subtitle || "You can't get it back once it’s deleted"}
						</BaseTypography>
					</Box>

					<Box id="buttons-cont" sx={deletePromptConfirmationModalStyles.buttonsCont}>
						<BaseButton
							id="cancel-button"
							styles={[reusableStyles.greenFilled, deletePromptConfirmationModalStyles.button]}
							onClick={handleClose}
						>
							<BaseTypography variant="b2_bold" styles={{ color: 'colors.dark6' }}>
								Cancel
							</BaseTypography>
						</BaseButton>
						<BaseButton
							id="delete-button"
							styles={[
								reusableStyles.light5Outlined,
								deletePromptConfirmationModalStyles.button,
								{ border: `1px solid ${colorPalette.light3}` },
							]}
							onClick={() => {
								dispatch(multiDeleteImageAsync());
							}}
						>
							<BaseTypography variant="b2_bold" styles={{ color: 'colors.light3' }}>
								Delete
							</BaseTypography>
						</BaseButton>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
}

export default DeletePromptConfirmationModal;
